document.addEventListener("DOMContentLoaded", function() {
    const $navbar  = $(".ct-height-inner.header");
    const $toolbar = $(".shopify-section--announcement-bar");
    let lastScrollTop = 0;

    $(window).scroll(function () {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop <= 50) {
            $navbar.removeClass("active bgcolor");
            $toolbar.removeClass("active bgcolor");
        }
        else if (scrollTop > lastScrollTop) {
            $navbar.addClass("active bgcolor");
            $toolbar.addClass("active bgcolor"); 
        }
        else if (scrollTop < lastScrollTop) {
            $navbar.removeClass("active"); 
            $toolbar.removeClass("active");    
        }

        lastScrollTop = scrollTop;
    });
    $(document).on('click', '.product-gallery__media', function() {
      $('.product-gallery__zoom-button').trigger('click');
    });
});

document.addEventListener("DOMContentLoaded", function() {
  const PREVIEW_DURATION = 3;
  let activeFullVideo = null;

  $("video.fr-video").each(function () {
    const video = this;
    const $wrap = $(video).closest(".vd-wrp");
    const $overlay = $wrap.find(".play-pause-wrap");
    startPreviewLoop(video);

    $overlay.on("click", function () {
      // Stop any currently active full video
      if (activeFullVideo && activeFullVideo !== video) {
        demoteToPausedFull(activeFullVideo);
      }
      stopPreviewLoop(video);     
      activeFullVideo = video;
      if (video.currentTime < PREVIEW_DURATION + 0.1) {
        video.currentTime = 0;
      }
      video.controls = true;
      video.muted = false;
      $overlay.fadeOut(200);
      video.play();
    });

    function startPreviewLoop(v) {
      v.controls = false;
      v.muted = true;
      v.play();
      const timer = setInterval(() => {
        if (v.currentTime >= PREVIEW_DURATION && activeFullVideo !== v) {
          v.pause();
          v.currentTime = 0;
          v.play();
        }
      }, 250);
      $(v).data("previewTimer", timer);
    }

    function stopPreviewLoop(v) {
      clearInterval($(v).data("previewTimer"));
    }
    function demoteToPausedFull(v) {
      v.pause();
      v.controls = false;
      v.muted = true;
      $(v).closest(".vd-wrp").find(".play-pause-wrap").fadeIn(200);
      activeFullVideo = null;
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const megaMenus = document.querySelectorAll(".ct-mega-menu-grid");

  megaMenus.forEach(menu => {
    const parents = menu.querySelectorAll(".ct-mm-parent-item");
    const childBlocks = menu.querySelectorAll(".ct-mm-child-block");

    // --- FIRST ITEM ACTIVE ONLY WITHIN THIS MENU ---
    if (parents.length > 0) {
      const firstParent = parents[0];
      const defaultKey = firstParent.dataset.parent;

      firstParent.classList.add("active");

      const defaultChild = menu.querySelector(`.ct-mm-child-block[data-parent="${defaultKey}"]`);
      if (defaultChild) defaultChild.style.display = "block";
    }

    // --- HOVER LOGIC (ONLY AFFECT THIS MENU) ---
    parents.forEach(parent => {
      parent.addEventListener("mouseenter", () => {
        const key = parent.dataset.parent;

        // remove active from only this menu's parents
        parents.forEach(p => p.classList.remove("active"));

        // hide only this menu's child blocks
        childBlocks.forEach(block => block.style.display = "none");

        // activate hovered
        parent.classList.add("active");

        // show correct child block
        const matchingChild = menu.querySelector(`.ct-mm-child-block[data-parent="${key}"]`);
        if (matchingChild) matchingChild.style.display = "block";
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".image-popup-vertical-fit")) {
    $(".image-popup-vertical-fit").magnificPopup({
      type: "image",
      mainClass: "mfp-with-zoom",
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1],
      },
      zoom: {
        enabled: true,
        duration: 300,
        easing: "ease-in-out",
        opener: function (element) {
          return element.is("img") ? element : element.find("img");
        },
      },
      removalDelay: 300,
    });
  }
});
